module.exports = __webpack_public_path__ + "img/jpg.507aa698.png";